import { useEffect, useRef, useState } from 'react';

// Dropdown che apre un pannello con checkbox per selezione multipla.
// Props:
//   - iconClass: classe Flaticon mostrata nel trigger (opzionale)
//   - placeholder: testo del trigger quando nulla è selezionato
//   - options: [{ value: string, label: string }]
//   - selected: string[] (valori attualmente selezionati)
//   - onChange: (next: string[]) => void
//   - selectedSummary: (count: number) => string (opzionale, custom format per il riassunto)
const DropdownMultiSelect = ({
    iconClass,
    placeholder,
    options,
    selected,
    onChange,
    selectedSummary
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const safeSelected = Array.isArray(selected) ? selected : [];

    const toggleValue = (val) => {
        const next = safeSelected.includes(val)
            ? safeSelected.filter(v => v !== val)
            : [...safeSelected, val];
        onChange(next);
    };

    const summary = safeSelected.length === 0
        ? placeholder
        : safeSelected.length === 1
            ? options.find(o => o.value === safeSelected[0])?.label || placeholder
            : (selectedSummary ? selectedSummary(safeSelected.length) : `${safeSelected.length} selezionati`);

    return (
        <div ref={containerRef} className="relative w-full">
            <button
                type="button"
                onClick={() => setIsOpen(v => !v)}
                className="w-full flex items-center justify-between gap-2 px-3 py-2 bg-white border border-neutral-200 rounded-full shadow-sm"
            >
                <span className="flex items-center gap-2 min-w-0">
                    {iconClass && <i className={`${iconClass} text-neutral-500 leading-none`}></i>}
                    <span className="text-sm truncate">{summary}</span>
                </span>
                <i className={`fi ${isOpen ? 'fi-rr-angle-small-up' : 'fi-rr-angle-small-down'} leading-none`}></i>
            </button>
            {isOpen && (
                <div className="absolute left-0 right-0 mt-1 bg-white border border-neutral-200 rounded-xl shadow-md z-30 max-h-64 overflow-y-auto">
                    {options.map((opt) => {
                        const checked = safeSelected.includes(opt.value);
                        return (
                            <label
                                key={opt.value}
                                className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-neutral-50 text-sm"
                            >
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={() => toggleValue(opt.value)}
                                />
                                <span>{opt.label}</span>
                            </label>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default DropdownMultiSelect;
